import { BalconySpecification } from '../../BalconySpecification';

type GetBalconySpecificationDepth = (roomSpecification: BalconySpecification) => number;
export const getBalconySpecificationDepth: GetBalconySpecificationDepth = (roomSpecification) =>
  roomSpecification.depth || roomSpecification.defaultDepth;
